import React, { Component } from 'react';
import ProgressBar from './ProgressBar';
import { ArrowLeft, Grid, Home, Plus, Search, BarChart2 } from 'react-feather';
import MobileMenu from './MobileMenu';
export default class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mobileMenuIsOpen: false
        };
    }

    renderDesktopHeader = () => {
        if (this.props.type === 'try') {
            return (
                <nav className="header">
                    <div className="header__left">
                        <a className="button button--secondary" href="https://synaptiq.co/library"><ArrowLeft/><span>Back to Library</span></a>
                    </div>
                    <div className='header__middle'><h1 className="header__middle__deck-title">{this.props.deck}</h1><ProgressBar percentMastery={this.props.percentMastery} /></div>
                    <div className="header__right">
                        {this.props.activeSession && <div className='counters'>
                            <div className={`counter new ${this.props.activeSession?.new > 99 ? 'small' : ''}`}>{this.props.activeSession?.new}</div>
                            <div className={`counter due ${this.props.activeSession?.due > 99 ? 'small' : ''}`}>{this.props.activeSession?.due}</div>
                        </div>}
                        <a href={this.props.headerButtonLink ? this.props.headerButtonLink : this.props.register} className='button' style={{whiteSpace: 'nowrap'}}>{this.props.headerButtonText ? this.props.headerButtonText : <><Plus/> Add Deck to Account</>}</a>
                    </div>
                </nav>
            )
        }
        else if (this.props.type === 'app') {
            return (
                <nav className="header">
                    <div className="header__left">
                        <a className="button button--secondary" href="https://www.synaptiq.app/"><Home/><span>Home</span></a>
                    </div>
                    <div className="header__right">
                        <a className="button button--secondary" href='https://www.synaptiq.app/app#/browse'><Search/><span>Browse</span></a>
                        <a className="button button--secondary" href='https://www.synaptiq.app/app#/stats'><BarChart2/><span>Stats</span></a>
                        <a className="button button--secondary" href='https://synaptiq.co/library'><Grid/><span>Library</span></a>
                    </div>
                </nav>
            );
        } else {
            return (
                <nav className="header header--web">
                    <a className="header__left__logo" href="https://synaptiq.co/">
                        {!this.props.thiemeLibrary && <img src={'./images/synaptiq-logo-full.svg'} alt="Synaptiq Logo" />}
                        {this.props.thiemeLibrary && <img src={'./images/thieme-synaptiq-logo.svg'} alt="Synaptiq x Thieme Logo" />}
                    </a>
                    <div>
                        <a className="navigation--link navigation--link--active" href="/library">Thieme x Synaptiq</a>
                        <a className="navigation--link" href="https://www.synaptiq.app/">Legacy Synaptiq</a>
                        <a className="button button--secondary" href="https://www.synaptiq.app/" target="_blank" rel="noreferrer">Sign In</a>
                        <a className="button" href="https://www.synaptiq.app/users/sign_up" target="_blank" rel="noreferrer">Get Started</a>
                    </div>
                </nav>
            );
        }
    }

    openMobileMenu = () => {
        this.setState({mobileMenuIsOpen: true});
    }

    closeMobileMenu = () => {
        this.setState({mobileMenuIsOpen: false});
    }

    renderMobileHeader = () => {
        if (this.props.type === 'try') {
            return (
                <nav className="header--mobile">
                    <button className="button button--secondary" onClick={() => window.history.back()}><ArrowLeft/></button>
                    <div className="header--mobile__right">
                        <div className='counters'>
                            <div className={`counter new ${this.props.activeSession?.new > 99 ? 'small' : ''}`}>{this.props.activeSession?.new}</div>
                            <div className={`counter due ${this.props.activeSession?.due > 99 ? 'small' : ''}`}>{this.props.activeSession?.due}</div>
                        </div>
                    </div>
                </nav>
            )
        } else {
            return (
                <nav className="header--mobile header--web-mobile">
                    <a href="https://synaptiq.co/"><img src={this.props.type === 'try' ? './images/synaptiq-logo-full.svg' : './images/synaptiq-logo-full.svg'} alt="Synaptiq Icon" /></a>
                    {/* <button className='menu-button' onClick={this.openMobileMenu}><img src="./images/icons/menu.svg" alt="Main Menu"/></button> */}
                </nav>
            );
        }
    }

    render() {
        return (
            <>
                {this.renderDesktopHeader()}
                {this.renderMobileHeader()}
                <MobileMenu
                    isOpen={this.state.mobileMenuIsOpen}
                    closeMenu={this.closeMobileMenu}
                />
            </>
        )
    }
}
